var e={name:"rzPreloader",props:{message:{type:String,default:""}}};export{e as default};
